module.exports = __webpack_public_path__ + "img/error_state_dark.b0076ac3.png";